import { useTestId } from '../../hooks/test-id.hook';
import { ButtonLink } from '../bootstrap/buttons/ButtonLink';
import { BsIcon } from '../icon/bs-icon.models';

interface Props {
    to: string;
    children: React.ReactNode;
    icon?: BsIcon;
}

export const PrimaryNavigationButton = ({ to, children, icon }: Props): React.ReactElement => {
    const testId = useTestId();

    return (
        <ButtonLink className="ml-2" to={to} icon={icon || 'plus-lg'} dataTestId={testId}>
            {children}
        </ButtonLink>
    );
};
